import React from "react";

const defaultRegulatoryCaseData = [
  { authority: "", caseBrief: "", actionTaken: "" },
];

const RegulatoryCaseTable = ({ regulatoryCaseData, setRegulatoryCaseData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...regulatoryCaseData];
    updated[index][field] = value;
    setRegulatoryCaseData(updated);
  };

  const addRow = () => {
    setRegulatoryCaseData([
      ...regulatoryCaseData,
      { authority: "", caseBrief: "", actionTaken: "" },
    ]);
  };

  const removeRow = () => {
    if (regulatoryCaseData.length > 1) {
      setRegulatoryCaseData(regulatoryCaseData.slice(0, -1));
    }
  };

  const cell = {
    border: "1px solid #000",
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const addButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  const removeButtonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div>
      <div
        style={{
          overflowX: "auto",
          marginTop: 20,
          border: "1px solid #000",
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={header}>Name of the Authority</th>
              <th style={header}>Brief of the case</th>
              <th style={header}>Corrective action taken</th>
            </tr>
          </thead>
          <tbody>
            {regulatoryCaseData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Name"
                    value={row.authority}
                    onChange={(e) =>
                      handleChange(index, "authority", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.caseBrief}
                    onChange={(e) =>
                      handleChange(index, "caseBrief", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Details"
                    value={row.actionTaken}
                    onChange={(e) =>
                      handleChange(index, "actionTaken", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default RegulatoryCaseTable;
